import { Component, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'app';

  constructor(private location: Location ,private router: Router, public route : ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object, @Optional() @Inject('REQUEST') private request: any) { 

   console.log("location", this.location.path());

  }
    
  ngOnInit() {
    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
        }
    });

    let userRole = null;
    let locationUrl = this.location.path();

    if (isPlatformServer(this.platformId) && this.request) {
        const cookies = this.request.headers.cookie || '';
        const match = cookies.match(/role=([^;]+)/);
        if (match) userRole = match[1];
    } else if (typeof localStorage !== 'undefined') {
        userRole = localStorage.getItem("role");
    }

    if( locationUrl == '/' || locationUrl == ''){
      if (userRole == null || userRole == undefined) {
        this.router.navigate(['/authentication/login/page']);
      }
      else if (userRole == "Admin") {
        console.log("navidate to Admin");
        this.router.navigate(['/']);
      }
      else if (userRole == "Mechanic") {
        console.log("navidate to Mechanic");
        this.router.navigate(['/mechanichome']);
      }
    }
  }
  
}
